var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: "Información del Servicio" } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.numero_cambio_servicio.label,
                  "prepend-icon": "123",
                  color: "primary",
                  disabled: _vm.accion_modal == "EDITAR"
                },
                on: {
                  input: function($event) {
                    return _vm.enviarNumero()
                  }
                },
                model: {
                  value: _vm.formFields.numero_cambio_servicio.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.numero_cambio_servicio,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.numero_cambio_servicio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("DatePicker", {
                    attrs: {
                      "prepend-icon": "event",
                      color: "primary",
                      label: _vm.formFields.fecha_de_alta.label,
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.fecha_de_alta.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fecha_de_alta, "value", $$v)
                      },
                      expression: "formFields.fecha_de_alta.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      "prepend-icon": "event",
                      color: "primary",
                      label: _vm.formFields.fecha_de_alta.label,
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.fecha_de_alta.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fecha_de_alta, "value", $$v)
                      },
                      expression: "formFields.fecha_de_alta.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("DatePicker", {
                    attrs: {
                      locale: "es-cl",
                      "prepend-icon": "event",
                      color: "primary",
                      label: _vm.formFields.fecha_de_instalacion.label,
                      max: _vm.fechaMaximaInicio.format("YYYY-MM-DD"),
                      disabled: _vm.accion_modal == "EDITAR"
                    },
                    model: {
                      value: _vm.formFields.fecha_de_instalacion.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.fecha_de_instalacion,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.fecha_de_instalacion.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      "prepend-icon": "event",
                      color: "primary",
                      label: _vm.formFields.fecha_de_instalacion.label,
                      disabled: _vm.accion_modal == "EDITAR"
                    },
                    model: {
                      value: _vm.formFields.fecha_de_instalacion.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.fecha_de_instalacion,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.fecha_de_instalacion.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "prepend-icon": "rule",
                  color: "primary",
                  label: _vm.formFields.numero_orden.label,
                  disabled: _vm.accion_modal == "EDITAR"
                },
                model: {
                  value: _vm.formFields.numero_orden.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.numero_orden, "value", $$v)
                  },
                  expression: "formFields.numero_orden.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "prepend-icon": "speaker_notes",
                  color: "primary",
                  label: _vm.formFields.observacion.label,
                  disabled: _vm.accion_modal == "EDITAR"
                },
                model: {
                  value: _vm.formFields.observacion.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.observacion, "value", $$v)
                  },
                  expression: "formFields.observacion.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "prepend-icon": "quick_reference",
                  color: "primary",
                  label: _vm.formFields.referencia.label,
                  disabled: _vm.accion_modal == "EDITAR"
                },
                model: {
                  value: _vm.formFields.referencia.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.referencia, "value", $$v)
                  },
                  expression: "formFields.referencia.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "item-text": "coorname",
                  items: _vm.filtro_coordinador,
                  "item-value": "coorid",
                  label: _vm.formFields.coordinador.label,
                  "prepend-icon": "supervisor_account",
                  disabled: _vm.accion_modal == "EDITAR"
                },
                model: {
                  value: _vm.formFields.coordinador.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.coordinador, "value", $$v)
                  },
                  expression: "formFields.coordinador.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "item-text": "tecniconame",
                  items: _vm.filtro_tecnicos,
                  "item-value": "tecnicoid",
                  label: _vm.formFields.tecnico_vigente.label,
                  "prepend-icon": "supervisor_account",
                  disabled: _vm.accion_modal == "EDITAR"
                },
                on: {
                  input: function($event) {
                    return _vm.enviar_tecnico()
                  }
                },
                model: {
                  value: _vm.formFields.tecnico_vigente.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.tecnico_vigente, "value", $$v)
                  },
                  expression: "formFields.tecnico_vigente.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }